import { EGroupItemType, GroupItem } from '@/models';

export const DEFAULT_WEBSITES: readonly GroupItem[] = [
  { itemType: EGroupItemType.website, itemValue: 'youtube.com' },
  { itemType: EGroupItemType.website, itemValue: 'instagram.com' },
  { itemType: EGroupItemType.website, itemValue: 'facebook.com' },
  { itemType: EGroupItemType.website, itemValue: 'reddit.com' },
  { itemType: EGroupItemType.website, itemValue: 'x.com' },
  { itemType: EGroupItemType.website, itemValue: 'pornhub.com' },
  { itemType: EGroupItemType.website, itemValue: 'tiktok.com' },
  { itemType: EGroupItemType.website, itemValue: 'netflix.com' },
  { itemType: EGroupItemType.website, itemValue: 'pinterest.com' },
  { itemType: EGroupItemType.website, itemValue: 'amazon.com' },
  { itemType: EGroupItemType.website, itemValue: 'roblox.com' },
] as const;

export const MOBILE_WEBSITES_COUNT = 6;

export const ONBOARDING_FLOW_PAGES = {
  ADD_ITEMS: 'addItems',
  SIGN_UP: 'signUp',
  OPT_IN: 'optIn',
  PURCHASE_FLOW: 'purchaseFlow',
} as const;

export type OnboardingFlowPage =
  (typeof ONBOARDING_FLOW_PAGES)[keyof typeof ONBOARDING_FLOW_PAGES];

export const ONBOARDING_FLOW_VERSIONS = {
  DEFAULT: '1.0',
  OPT_IN_FIRST: '2.0',
} as const;

export type OnboardingFlowVersion =
  (typeof ONBOARDING_FLOW_VERSIONS)[keyof typeof ONBOARDING_FLOW_VERSIONS];

interface ScreenAction {
  next?: OnboardingFlowPage;
  skip?: OnboardingFlowPage;
}

interface Screen {
  actions: ScreenAction;
}

export interface OnboardingFlowConfig {
  version: OnboardingFlowVersion;
  initialScreen: OnboardingFlowPage;
  screens: {
    [key in OnboardingFlowPage]?: Screen;
  };
}

export const onboardingFlow: OnboardingFlowConfig = {
  version: ONBOARDING_FLOW_VERSIONS.DEFAULT,
  initialScreen: ONBOARDING_FLOW_PAGES.ADD_ITEMS,
  screens: {
    addItems: {
      actions: {
        next: ONBOARDING_FLOW_PAGES.SIGN_UP,
        skip: ONBOARDING_FLOW_PAGES.SIGN_UP,
      },
    },
    signUp: {
      actions: {
        next: ONBOARDING_FLOW_PAGES.OPT_IN,
        skip: ONBOARDING_FLOW_PAGES.OPT_IN,
      },
    },
    optIn: {
      actions: {
        next: ONBOARDING_FLOW_PAGES.PURCHASE_FLOW,
        skip: ONBOARDING_FLOW_PAGES.PURCHASE_FLOW,
      },
    },
    purchaseFlow: {
      actions: {},
    },
  },
};

export const onboardingFlowOptInFirst: OnboardingFlowConfig = {
  version: ONBOARDING_FLOW_VERSIONS.OPT_IN_FIRST,
  initialScreen: ONBOARDING_FLOW_PAGES.OPT_IN,
  screens: {
    optIn: {
      actions: {
        next: ONBOARDING_FLOW_PAGES.ADD_ITEMS,
        skip: ONBOARDING_FLOW_PAGES.ADD_ITEMS,
      },
    },
    addItems: {
      actions: {
        next: ONBOARDING_FLOW_PAGES.SIGN_UP,
        skip: ONBOARDING_FLOW_PAGES.SIGN_UP,
      },
    },
    signUp: {
      actions: {
        next: ONBOARDING_FLOW_PAGES.PURCHASE_FLOW,
        skip: ONBOARDING_FLOW_PAGES.PURCHASE_FLOW,
      },
    },
    purchaseFlow: {
      actions: {},
    },
  },
};

export const ONBOARDING_FLOW_BY_VERSION: Record<
  OnboardingFlowVersion,
  OnboardingFlowConfig
> = {
  [ONBOARDING_FLOW_VERSIONS.DEFAULT]: onboardingFlow,
  [ONBOARDING_FLOW_VERSIONS.OPT_IN_FIRST]: onboardingFlowOptInFirst,
};
